import logo from "../assets/newlogo.svg";
// import { useHistory } from 'react-router-dom';
export const Logo = () => {
	// const history = useHistory();
	return (
		<img
			src={logo}
			alt="logo"
			style={{
				margin: "0 auto",
				maxWidth: 100,
				width: "100%",
				padding: 15,
				borderRadius: 20,
			}}
		/>
	);
};
